import { useRecoilState } from "recoil";
import AtomStore from "services/atomStore";
import { EVENT_NAMES } from "./EVENTS";
AtomStore.setAtom("eventManagerState", {});

const { eventManagerState } = AtomStore.getAtom();

const useEventManager = () => {
    const [events, setEvents] = useRecoilState(eventManagerState);

    const _publish = (name, data) => {
        let handlers = events[name];
        if (!!handlers === false) return;
        handlers.forEach(function (handler) {
            handler.call(this, data);
        });
    };

    const _subscribe = (name, handler) => {
        let handlers =
            !!events[name]
                ? { ...events, [name]: [...events[name], handler] }
                : { ...events, [name]: [handler] }
        setEvents(handlers);
    };

    const _unsubscribe = (name, handler) => {
        let handlers = events[name];
        if (!!handlers === false) return;
        setEvents({
            ...events,
            [name]: handlers.filter((ele) =>  ele !== handler )
        });
    };


    const showNotification = (params) => {
        let timeOut = params.timer || 15;
        _publish("notify", { show: false });
        if (params.show === true) {
            _publish("notify", params);
            setTimeout(() => {
                _publish("notify", { show: false });
            }, timeOut * 1000);
        }
    }

    const showLoader = (show) => {
        _publish("loader", { show });
    }

    return { _publish, _subscribe, _unsubscribe, showNotification, showLoader, events, EVENT_NAMES }
}

export default useEventManager;
